// extracted by mini-css-extract-plugin
export default {"title":"basicInfo_title__guGDX","imgCol":"basicInfo_imgCol__-baEn"};